import i18next from 'i18next'

import { getBrandbookPath } from 'utils/helpers/getBrandbookPath'
import { docs } from 'shared/constants/docs'
import { LKRoutesEnum, PromoGeRoutesEnum, PromoRoutesEnum } from 'shared/constants/routes'
import { URLS } from 'shared/constants/urls'
import { SCROLL_TO_ID } from 'shared/constants/values'

import { MenuItemType, PromoPageKeys } from './types'

const getSharedKey = (key: string) => `${PromoPageKeys.shared}.${key}`

export const menuItems: MenuItemType[] = [
  { id: 1, type: 'link', label: 'Карта', path: URLS.pick_point_map },
  { id: 2, type: 'anchor', label: 'Как открыть ПВЗ', path: `#${SCROLL_TO_ID.openingSection}` },
  { id: 3, type: 'anchor', label: 'Виды ПВЗ', path: `#${SCROLL_TO_ID.pickPointKinds}` },
  { id: 4, type: 'link', label: 'Оферта', path: URLS.offer },
  { id: 5, type: 'link', label: 'Ремонт и оформление', path: docs.brandbook },
]

export const home: MenuItemType = { id: 6, type: 'anchor', label: 'wb point', path: '#home' }

export const partnerLinks: MenuItemType[] = [
  { id: 19, type: 'path', label: 'Приложения', path: PromoRoutesEnum.apps },
  { id: 11, type: 'path', label: 'Печатные материалы', path: PromoRoutesEnum.banners },
  { id: 9, type: 'link', label: 'Экобокс', path: docs.ecobox },
  { id: 20, type: 'link', label: 'Арендодателю', path: URLS.wb_rent },
]

export const companyLinks: MenuItemType[] = [
  { id: 12, type: 'link', label: 'Брендбук для стандартных условий', path: docs.brandbook },
  { id: 23, type: 'link', label: 'Брендбук для упрощенных условий', path: docs.brandbookSimplified },
  { id: 10, type: 'path', label: 'Вывеска', path: PromoRoutesEnum.signboard },
  { id: 8, type: 'path', label: 'Видеонаблюдение', path: PromoRoutesEnum.videoConnection },
  { id: 18, type: 'path', label: 'Электронные замки', path: PromoRoutesEnum.eLock },
]

export const simplifiedConditionsLink: MenuItemType = {
  id: 25,
  type: 'path',
  label: 'Упрощённые условия',
  path: PromoRoutesEnum.simplifiedConditions,
}

export const otherLinks: MenuItemType[] = [
  { id: 13, type: 'path', label: 'Календарь конференций', path: PromoRoutesEnum.conferences },
  { id: 25, type: 'link', label: 'Портал обучения', path: URLS.learningPortal },
]

export const policyLinks: MenuItemType[] = [
  { id: 14, type: 'link', label: 'Оферта', path: URLS.offer },
  { id: 15, type: 'link', label: 'Политика конфиденциальности', path: PromoRoutesEnum.privacyPolicy },
]

export const openPickPointLink: MenuItemType = {
  id: 16,
  type: 'anchor',
  label: 'Открыть ПВЗ',
  path: `#${SCROLL_TO_ID.authForm}`,
}

export const openPickPointLinkMobile: MenuItemType = {
  id: 27,
  type: 'anchor',
  label: 'Открыть ПВЗ',
  path: `#${SCROLL_TO_ID.authFormMobile}`,
}

export const loginLink: MenuItemType = {
  id: 17,
  type: 'path',
  label: 'Личный кабинет',
  path: LKRoutesEnum.orders,
}

export const getHeaderGeItems = (): MenuItemType[] => {
  return [
    { id: 18, type: 'link', label: 'Карта', path: URLS.pick_point_map_ge },
    {
      id: 20,
      type: 'link',
      label: 'Брендбук',
      path: getBrandbookPath(),
    },
    { id: 21, type: 'link', label: 'Оферта', path: URLS.ofertaGe },
  ]
}

export const headerItems: MenuItemType[] = [
  { id: 18, type: 'path', label: 'Карта', path: PromoRoutesEnum.map },
  { id: 21, type: 'link', label: 'Оферта', path: URLS.offer },
  { id: 24, type: 'path', label: 'Упрощённые условия', path: PromoRoutesEnum.simplifiedConditions },
  { id: 25, type: 'path', label: 'База знаний', path: PromoRoutesEnum.knowledgeBase },
]

export const loginGePageLink: MenuItemType = {
  id: 22,
  type: 'path',
  label: i18next.t(getSharedKey('Открыть ПВЗ')),
  path: PromoGeRoutesEnum.login,
}

export const auctionData = [
  {
    title: 'Или купите готовый ПВЗ',
    description: 'Если не хотите искать помещение и заниматься ремонтом',
    linkText: 'Посмотреть варианты',
    linkHref: URLS.auction,
    eventSection: 'Аукцион',
  },
]

export const knowledgeBaseHeaderItems: MenuItemType[] = [
  { id: 21, type: 'link', label: 'Оферта', path: URLS.offer },
]
